import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAddProgress,
        popUpMessageChange, 
        closedCardsGroupsChange,
        editCards, 
        setCycleData, 
        deleteCards, 
        editFeaturesGroup, 
        editFigures } from '../../../actions';

import { _ } from '../../../functions/translator.js';

import { Button, 
        MenuItem, 
        Select } from '@material-ui/core';

import SendIcon from '@material-ui/icons/Send';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { postData } from '../../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../../functions/map/reloadCardsGroups';
import { showMessage } from '../../../functions/popUpMessage.js';

class CycleNameCard extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            zoneId: 0,
        }
    }

    componentDidUpdate() {
        if (this.state.zoneId) return
        let zonesData = Object.values(this.props.projectData.zones)
        if (zonesData.length > 0) {
            this.setState({ zoneId: zonesData[0].id })
        }
    }


    handleOnClick = async () => {
        const message = _("Generando Ciclo") + '...';
        showMessage(this.props, message, { loading: true });
        const zoneId = this.state.zoneId ? this.state.zoneId : null;
        let urlPost = {
            project_id: this.props.projectData.id,
            zone_id: zoneId,
            cycle_only: true,
            cards_group_ids: this.props.generateCycle.cardsGroupIds,
        }
        let cardsGroupIds = this.props.generateCycle.cardsGroupIds
        this.handleClose()
        let response = await postData('/web-api/merge-cards-groups', urlPost)
        this.handleResponse(response, cardsGroupIds)
    }

    handleClose = () => {
        this.props.setCycleData({})
        this.setState({ zoneId: 0 })
    }

    handleResponse = (response, cardsGroupIds) => {
        if(response) {
            reloadCardsGroupsFeatures(this.props, cardsGroupIds)
            showMessage(this.props, '¡' + _('Se ha generado el ciclo correctamente') + '!');
        } else {
            showMessage(this.props, _('No se pudo generar el ciclo') + '.');
        }
    }

    handleZoneChange = (event) => {
        this.setState({ zoneId: event.target.value })
    }

    render(){   
        let render = this.props.generateCycle.show
        let options = []
        let zonesData = this.props.projectData.zones
        for (const zone of Object.values(zonesData)) {
            options.push(<MenuItem value={zone.id} key={zone.id}>{zone.attributes.name}</MenuItem>)
        }
        return (
            <div>
                { render ? (
                    <div>
                        <div className='sensitive-background' onClick={this.handleClose}></div>
                        { options.length > 0 ? (
                        <div className="add-progress-card-layout card-color">
                            <h3 className='text-center mb-4'>{_("Seleccione un Ciclo")}</h3>
                            <Select
                                value={this.state.zoneId}
                                onChange={this.handleZoneChange}>
                            {options}
                            </Select>
                            <div className='d-flex justify-content-center'>
                                <Button variant="contained" onClick={this.handleOnClick} className='success-button mt-4'>
                                    <SendIcon/>
                                    <span style={{ paddingLeft: 10 }}>{ _('Generar')}</span>
                                </Button>
                            </div>
                        </div>
                        ) : (
                        <div className="add-progress-card-layout card-color">
                            <h3 className='text-center text-color mb-4'>{_("No hay ciclos disponibles, agregue ciclos antes de continuar")}.</h3>
                            <div className='d-flex justify-content-center'>
                                <Button variant="contained" href={'/zones?project_id='+ window.project_id}>
                                    <ArrowForwardIcon/>
                                    <span style={{ paddingLeft: 10 }}>{ _('Ir a Ciclos')}</span>
                                </Button>
                            </div>
                        </div>
                        )}
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        generateCycle : state.generateCycle
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        setAddProgress : setAddProgress,
        popUpMessageChange : popUpMessageChange,
        closedCardsGroupsChange : closedCardsGroupsChange,
        setCycleData : setCycleData,
        deleteCards : deleteCards,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CycleNameCard)